import React from 'react';
import I18n from 'i18n-js';
import SanitizedRender from './sanitized_render';
import { RCPopover, RCIcon, useMediaQuery } from '@reverbdotcom/cadence/components';
import { InfoIcon } from '@reverbdotcom/cadence/icons/react';
import { REVERB_BUMP } from '../url_helpers';
import classNames from 'classnames';

export function BumpDSACompliancePopover({ inNewSearchOverviewExp = false }: { inNewSearchOverviewExp?: boolean }) {
  const isTablet = useMediaQuery('tablet');
  const isMobile = useMediaQuery('mobile');
  const isTabletOrMobile = isMobile || isTablet;
  const position = isTabletOrMobile ? 'bottom-start' : 'right';

  const classes = classNames({
    'mb-1 mt-1 pt-1': !inNewSearchOverviewExp,
  });
  const textStyle = classNames({
    'color-secondary size-fixed-90': !inNewSearchOverviewExp,
  });
  const buttonClasses = classNames({
    'bump-dsa-compliance-popover--new': inNewSearchOverviewExp,
    'bump-dsa-compliance-popover': !inNewSearchOverviewExp,
  });

  return (
    <div className={classes}>
      <RCPopover
        position={position}
        anchor={
          <button type="button" className={buttonClasses}>
            <span className={textStyle}>
              {I18n.t('commons.bump.dsaCompliancePopover.title')}
            </span>
            {!inNewSearchOverviewExp &&
              <span className="color-secondary size-fixed-100">
                <RCIcon svgComponent={InfoIcon} size="inline" />
              </span>
            }
            <span className="visually-hidden">{I18n.t('commons.bump.dsaCompliancePopover.learnMore')}</span>
          </button>
        }
      >
        <SanitizedRender
          htmlTag="span"
          html={I18n.t('commons.bump.dsaCompliancePopover.description', {
            linkOpen: `<a href="${REVERB_BUMP}" target=_blank class="text-link" rel="nofollow">`,
            linkClose: '</a>',
          })}
        />
      </RCPopover>
    </div>
  );
}
